import { render, staticRenderFns } from "./protocols.vue?vue&type=template&id=54ef5e3d&scoped=true&"
import script from "./protocols.vue?vue&type=script&lang=js&"
export * from "./protocols.vue?vue&type=script&lang=js&"
import style0 from "./protocols.vue?vue&type=style&index=0&id=54ef5e3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef5e3d",
  null
  
)

export default component.exports